export const ACard = ({ children, className = "", ...p }) => (
  <div className={`rounded-2xl bg-[var(--kh-ws-card)] border border-white/5 p-5 sm:p-6 ${className}`} {...p}>{children}</div>
);

export const AH1 = ({ children, action }) => (
  <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
    <h1 className="font-heading text-2xl sm:text-3xl font-bold text-white">{children}</h1>
    {action}
  </div>
);

const base = "w-full bg-[var(--kh-ws)] border border-white/10 rounded-xl px-3.5 py-2.5 text-sm focus:outline-none focus:border-[var(--kh-violet)] transition-colors";

export const AField = ({ label, hint, testid, textarea, className = "", ...p }) => (
  <label className={`block space-y-1.5 ${className}`}>
    <span className="text-xs text-slate-400">{label}</span>
    {textarea ? <textarea {...p} data-testid={testid} className={`${base} min-h-[96px]`} /> : <input {...p} data-testid={testid} className={base} />}
    {hint && <span className="block text-[11px] text-slate-500">{hint}</span>}
  </label>
);

export const ABtn = ({ children, variant = "primary", className = "", ...p }) => {
  const v = {
    primary: "bg-[var(--kh-violet)] hover:bg-[#7C3AED] text-white",
    ghost: "bg-white/5 hover:bg-white/10 text-slate-200",
    danger: "bg-red-500/15 hover:bg-red-500/25 text-red-300",
    success: "bg-emerald-500/15 hover:bg-emerald-500/25 text-emerald-300",
  }[variant];
  return <button {...p} className={`inline-flex items-center justify-center gap-2 px-4 py-2 rounded-xl text-sm font-medium transition-colors disabled:opacity-50 ${v} ${className}`}>{children}</button>;
};

const STATUS = { pending: ["قيد المراجعة", "bg-yellow-400/15 text-yellow-300"], approved: ["مقبول", "bg-emerald-400/15 text-emerald-300"], rejected: ["مرفوض", "bg-red-400/15 text-red-300"], active: ["مفعّل", "bg-emerald-400/15 text-emerald-300"], revoked: ["ملغي", "bg-red-400/15 text-red-300"] };
export const Status = ({ s, testid }) => {
  const [l, c] = STATUS[s] || [s, "bg-white/10"];
  return <span className={`inline-block text-xs px-2.5 py-1 rounded-full ${c}`} data-testid={testid}>{l}</span>;
};

export const METHOD = { vodafone_cash: "فودافون كاش", instapay: "إنستاباي" };
export const fmtDate = (d) => (d ? new Date(d).toLocaleString("ar-EG", { dateStyle: "medium", timeStyle: "short" }) : "—");
